export const getIconFromLibrary = (library, iconName) => library[iconName];

export const setViewBox = (width, height) => {
  const difference = height - width;
  const currentHeight = difference + 24;

  return `0 0 24 ${currentHeight}`;
};
